import { GET_AUTOMATED_REPORTS_FAILURE, GET_AUTOMATED_REPORTS_REQUEST, GET_AUTOMATED_REPORTS_SUCCESS, GetAutomatedReportsActionTypes, GetAutomatedReportsState } from './types';

const defaultState: GetAutomatedReportsState = {
  isLoading: false,
  errorMessage: "",
};

export default function getAutomatedReports(state = defaultState, action: GetAutomatedReportsActionTypes): GetAutomatedReportsState {
  switch (action.type) {
    case GET_AUTOMATED_REPORTS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_AUTOMATED_REPORTS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_AUTOMATED_REPORTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
